import { getApiConfig } from '../utils/apiUtils';
import axios from 'axios';

const API_BASE = '/distribution/api/channels';

export const fetchAllChannels = async () => {
  const response = await axios.get(`${API_BASE}/`, getApiConfig());
  return response.data;
};

export const fetchChannelById = async (channelId) => {
  const response = await axios.get(`${API_BASE}/${channelId}/`, getApiConfig());
  return response.data;
};

export const createChannel = async (channelData) => {
  const response = await axios.post(`${API_BASE}/`, channelData, getApiConfig());
  return response.data;
};

export const updateChannel = async (channelId, channelData) => {
  const response = await axios.put(`${API_BASE}/${channelId}/`, channelData, getApiConfig());
  return response.data;
};

export const deleteChannel = async (channelId) => {
  const response = await axios.delete(`${API_BASE}/${channelId}/`, getApiConfig());
  return response.data;
};

export const fetchOTAImages = async () => {
  const response = await axios.get('/distribution/api/ota-images/', getApiConfig());
  return response.data;
};
